import { render, staticRenderFns } from "./DHXB.vue?vue&type=template&id=8cd243a0&scoped=true"
import script from "./DHXB.vue?vue&type=script&lang=js"
export * from "./DHXB.vue?vue&type=script&lang=js"
import style0 from "./DHXB.vue?vue&type=style&index=0&id=8cd243a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd243a0",
  null
  
)

export default component.exports